import { render, staticRenderFns } from "./EditCategoryForm.vue?vue&type=template&id=1c2a86ca&scoped=true&"
import script from "./EditCategoryForm.vue?vue&type=script&lang=js&"
export * from "./EditCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a86ca",
  null
  
)

export default component.exports